export { default } from './DoubleCurrencyLogo'
